<ng-container *ngIf="notificationBannerService.notifications$ | async as messages">
  <p-accordion [expandIcon]="'pi pi-chevron-down'" [collapseIcon]="'pi pi-chevron-up'">
    <p-accordionTab [(selected)]="isSelected">
      <p-header [ngClass]="{ 'max-height': !isSelected }">
        <div>{{ messages[0] }}</div>
        <div class="counter" *ngIf="messages.length > 1 && !isSelected">
          Всего сообщений: {{ messages.length }}
        </div>
      </p-header>
      <div (click)="isSelected = false" class="message" *ngFor="let message of messages.slice(1)">
        {{ message }}
      </div>
    </p-accordionTab>
  </p-accordion>
</ng-container>
